const form = {
	display_name: {
		helper: "Provide a display name for your daDup account.",
		label: "Display name",
		placeholder: "Bucket_Holder_01",
		placeholder_example: "For example: Bucket_Holder_01",
	},
};

export default form;
